export default __webpack_public_path__ + "static/media/V420_E_BD.3db75aee.pdf";